export type TradingSymbolsList = {
    id: string;
    name: string;
    isSystem: boolean;
    description: string;
    type: TradingSymbolsListType;
    symbols: string[] | null | undefined;
    screenerRules: ScreenereRules | null | undefined;
};

export enum TradingSymbolsListType {
    Unknown = 0,
    StaticList = 1,
    StocksScreener = 2,
}

export type ScreenereRules = {};
